import { createContext, useContext, useState } from "react";
import { useParams } from "react-router";


type Props = {
  children: React.ReactNode;
}

type SlugCtx  = {
  slug_id: string;
}

const Context = createContext<SlugCtx>({} as SlugCtx);

export const SlugProvider : React.FC<Props> = ({children}) => {

  const params = useParams<{slug_id?: string}>();
  const slug_id = params.slug_id ? params.slug_id : 'la-urbana-burguer-bar';

  return (
    <Context.Provider
      value={{ slug_id: slug_id }}
    >
      {children}
    </Context.Provider>
  );
}

export const useSlugContext = () => {

  const context = useContext(Context);

  if(context.slug_id === undefined) throw new Error('useCartContext must be inside SlugProvider');

  return context;

}